import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "w-full mt-4 flex flex-col gap-4",
  style: {"grid-area":"table"}
}
const _hoisted_2 = { class: "overflow-x-auto rounded-lg shadow-sm border border-gray-200 min-h-[300px]" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"hidden md:grid lg:grid-cols-12 md:grid-cols-6 gap-1 w-full items-center px-4 py-2 text-sm text-gray-500 font-semibold\" style=\"background:var(--Neutral-LightGray-5, #fafafa);\"><div class=\"lg:col-span-3 md:col-span-4 flex\"><p class=\"ml-14 text-start\">Nome</p></div><div class=\"lg:col-span-3 hidden lg:block\"><p class=\"text-start\">Email</p></div><div class=\"lg:col-span-2 hidden lg:block\"><p class=\"text-start\">Telefone</p></div><div class=\"lg:col-span-2 hidden lg:block\"><p class=\"text-start\">Empresas</p></div><div class=\"lg:col-span-2 md:col-span-2 text-center\"><p>Ações</p></div></div>", 1)
const _hoisted_4 = {
  key: 0,
  class: "flex justify-center py-2"
}

import TableUsers from '@/components/designSystem/Table/TableUsers.vue'
import UserTableSkeleton from '@/components/designSystem/Skeleton/UserTableSkeleton.vue'
import { useUserStore } from '@/pinia-store/useUsersStore'
import { storeToRefs } from 'pinia'
import EmptyList from '@/components/EmptyList.vue'
import { ref, computed, watch } from 'vue'
import EditUserModal from './components/UpdateUserModal/Index.vue'
import { CompanyUserResponse } from '@/Network/Types/Responses/CompanyResponses'


export default /*#__PURE__*/_defineComponent({
  __name: 'user.tab',
  setup(__props) {

const showEditUserModal = ref(false)
const userToEdit = ref<CompanyUserResponse | null>(null)
const userStore = useUserStore()
const { users, isLoading } = storeToRefs(userStore)

const currentPage = ref(1)
const itemsPerPage = ref(8)

const paginatedUsers = computed(() => {
  if (!users.value?.data) return []
  const start = (currentPage.value - 1) * itemsPerPage.value
  return users.value.data.slice(start, start + itemsPerPage.value)
})

const pageCount = computed(() => {
  if (!users.value?.data) return 0
  return Math.ceil(users.value.data.length / itemsPerPage.value)
})

const changePage = (page: number) => {
  currentPage.value = page
}

watch(
  () => users.value?.data?.length,
  () => {
    currentPage.value = 1
  }
)

const handleOpenEditModal = (userData: CompanyUserResponse) => {
  userToEdit.value = userData
  showEditUserModal.value = true
}

const handleCloseEditModal = () => {
  showEditUserModal.value = false
  userToEdit.value = null
}

const handleUserUpdated = () => {
  handleCloseEditModal()
  userStore.fetchUsers()
}

return (_ctx: any,_cache: any) => {
  const _component_v_pagination = _resolveComponent("v-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isLoading))
      ? (_openBlock(), _createBlock(UserTableSkeleton, { key: 0 }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            (_unref(users)?.data && _unref(users).data.length > 0)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(paginatedUsers.value, (companyUser) => {
                  return (_openBlock(), _createBlock(TableUsers, {
                    key: companyUser.user.id,
                    data: companyUser,
                    onEditUser: handleOpenEditModal
                  }, null, 8, ["data"]))
                }), 128))
              : (_openBlock(), _createBlock(EmptyList, {
                  key: 1,
                  title: "Nenhum usuário foi encontrado",
                  class: "py-12"
                }))
          ]),
          (_unref(users)?.data && _unref(users).data.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_v_pagination, {
                  modelValue: currentPage.value,
                  "onUpdate:modelValue": [
                    _cache[0] || (_cache[0] = ($event: any) => ((currentPage).value = $event)),
                    changePage
                  ],
                  "total-visible": 3,
                  length: pageCount.value,
                  density: "comfortable",
                  color: "primary"
                }, null, 8, ["modelValue", "length"])
              ]))
            : _createCommentVNode("", true)
        ], 64)),
    (showEditUserModal.value)
      ? (_openBlock(), _createBlock(EditUserModal, {
          key: 2,
          modalActive: showEditUserModal.value,
          userData: userToEdit.value,
          onClose: handleCloseEditModal,
          onUserUpdated: handleUserUpdated
        }, null, 8, ["modalActive", "userData"]))
      : _createCommentVNode("", true)
  ]))
}
}

})